import { Response } from 'superagent'
import { sendRequest } from './superagent'

export async function apiGetValuesStart (): Promise<Response> {
  return await sendRequest('get', 'valuesstart')
}
